export default {
  methods: {
    handleStatus (status) {
      if (!status) { return }
      const status_new = status.toUpperCase()
      switch (status_new) {
        case 'DOCTOR_END_CALL': return 'SUKSES'
        case 'PATIENT_END_CALL': return 'SUKSES'
        case 'COMPLETED': return 'SUKSES'
        case 'CANCELLED': return 'DIBATALKAN'
        case 'TIME_OUT': return 'SUKSES'
        case 'DOCTOR_ACCIDENT': return 'SUKSES'
        case 'PATIENT_ACCIDENT': return 'SUKSES'
        case 'RATING': return 'SUKSES'

        case 'PATIENT_NO_ANSWER': return 'PASIEN GAGAL JAWAB'
        case 'PATIENT_MISSED_CALL': return 'PASIEN GAGAL JAWAB'
        case 'PATIENT_CANCEL': return 'PASIEN GAGAL JAWAB'

        case 'PATIENT_REJECT': return 'PASIEN TOLAK PANGGILAN'

        case 'DOCTOR_NO_ANSWER': return 'DOKTER GAGAL PANGGIL'
        case 'BOTH_NO_ANSWER': return 'DOKTER GAGAL PANGGIL'

        case 'UNFINISHED': return 'DOKTER GAGAL RANGKUMAN'
        case 'UNFINISHED_SUMMARY' : return 'DOKTER GAGAL RANGKUMAN'
      }

      return status_new.replace(/[_-]/g, ' ')
    },
    classBadge (status) {
      switch (status) {
        case 'PENDING': return 'yd-badge-light-warning'
        case 'SOLVED': return 'yd-badge-light-success'
        case 'SUKSES': return 'badge_success'
        case 'DIBATALKAN': return 'badge_grey'
        case 'NOT READY': return 'badge_grey'
        case 'RATING': return 'badge_yellow'
        case 'PASIEN GAGAL JAWAB': return 'badge_red'
        case 'PASIEN TOLAK PANGGILAN': return 'badge_red'
        case 'DOKTER GAGAL PANGGIL': return 'badge_darkred'
        case 'DOKTER GAGAL RANGKUMAN': return 'badge_darkred'
        default: return ''
      }
    },
    compareString (str1, str2) {
      return str1.toLowerCase() === str2.toLowerCase()
    }
  }
}
